module.exports = "https://static.wanderu.com/static/media/favicon.ico";